import { styled } from '@clickcease/cc-client-components-lib'
import { CSSProperties } from 'react'
import { CSS, keyframes } from '@stitches/react'

export const EditBillingDetailsModalStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '692px',
  height: '505px',
  padding: '20px 24px',
})

export const EditBillingDetailsSubTitle = styled('div', {
  fontSize: '$sm',
  marginBottom: '10px',
  color: '$fontColor',
})

export const EditBillingDetailsContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const EditBillingDetailsRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  marginBottom: '15px',
  maxWidth: '100%',
  gap: '$8',

  ['> button']: {
    maxWidth: '218px',
  },
  ['> div']: {
    margin: 0,
  },

  variants: {
    haveFourFields: {
      true: {
        ['> input']: {
          maxWidth: '120px',
        },

        ['> button']: {
          maxWidth: '120px',
        },
      },
    },
  },
})

export const ErrorStyled = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$md',

  variants: {
    fixMargin: {
      true: {
        marginTop: '15px',
      },
    },
  },
})

export const vatInfoTriggerStyles: CSSProperties = {
  position: 'absolute',
  right: 0,
}

export const vatInfoBorderStyles: CSS = {
  maxWidth: '250px',
  maxHeight: '100px',
}

export const InputWrapper = styled('div', {
  display: 'flex',
  position: 'relative',
  ['> *']: {
    margin: 0,
  },
})

export const EditBillingDetailsHelpSection = styled('div', {
  fontSize: '$md',
  padding: '26px',
  textAlign: 'center',
})

const glowAnimation = keyframes({
  '0%': {
    borderColor: '#ff0000',
    boxShadow: '0 0 5px #ff0000',
  },
  '100%': {
    borderColor: '#ccc',
    boxShadow: 'none',
  },
})

export const animatedInputStyles = (isGlowing: boolean) => ({
  animation: isGlowing ? `${glowAnimation.toString()} 1.5s ease-out` : 'none',
})
